import { useState } from "react";
import styles from './ag.module.css';

function AG(item) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div tabIndex={0} className={styles.card}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {

                    e.preventDefault(); // Prevent space from scrolling
                    setIsOpen(!isOpen)
                }
            }}
        >
            <div className={styles.title} onClick={() => setIsOpen(!isOpen)}>
                <p className={styles.name}>{item.name}</p>
                <div className={styles.spacer}>
                    <p className={styles.class}>Klassen: {item.class}</p>
                    <svg className={`${styles.gt} ${isOpen ? styles.rotated : ""}`} style={{ cursor: "pointer" }} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.28 122.88" >
                        <title>greater-than</title>
                        <polygon points="0 122.88 103.28 76.93 103.28 45.95 0 0 0 33.94 75.46 61.34 0 88.74 0 122.88 0 122.88" />
                    </svg>
                </div>
            </div>
            <div className={`${styles.content} ${isOpen ? styles.show : styles.hide}`}>
                <img className={styles.contentImg}
                    src={`${process.env.PUBLIC_URL}${item.img}`}
                    alt={item.imgText} />
                <div className={styles.contentText}>
                    {item.text.split("\n\n").map((paragraph, index) => (
                        <span className={styles.span} key={index}>
                            {paragraph}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AG;
